import {Injectable} from '@angular/core';
import gql from 'graphql-tag';
import {VisbosService} from '../../core/visbos-core/graphql/visbos.service';
import {NgRedux, select} from '@angular-redux/store';
import {Observable} from 'rxjs';
import {Apollo, ApolloQueryObservable} from 'apollo-angular';
import {IAppState} from '../../shared/redux-store';
import {SessionActions} from '../../shared/actions';
import {
  RegisterAssetForArticleMutation,
  RegisterAssetForArticleMutationVariables,
  ResolveAssetTreeByEPCsQuery,
  ResolveAssetTreeByEPCsQueryVariables,
  ResolveItemsByEPCsQuery,
  ResolveItemsByEPCsQueryVariables,
  RetrieveEPCsByReaderQuery,
  RetrieveEPCsByReaderQueryVariables,
  RetrievePackingEPCsByReaderQuery,
  RetrievePackingEPCsByReaderQueryVariables
} from '../../shared/graphql/graphql.types';
import {environment} from '../../../environments/environment';
import {ApolloQueryResult, FetchPolicy, WatchQueryOptions} from 'apollo-client';

export const retrieveEPCsFromReader = gql`
  query RetrieveEPCsByReader($readerCuid:ID) {
    epcsByReader(readerCuid:$readerCuid)
  }
`;

export const retrievePackingEPCsFromReader = gql`
  query RetrievePackingEPCsByReader($readerCuid:ID) {
    packingEpcsFromReader(readerCuid:$readerCuid)
  }
`;

export const resolveItemsByEPCs = gql`
  query ResolveItemsByEPCs($epcs: [String]!, $includeChildren: Boolean) {
    itemsByEPCs(epcs: $epcs, includeChildren: $includeChildren) {
      cuid, label
      ... on Asset {
        cuid label
        article {cuid label}
      }
    }
  }
`;

export const resolveAssetTreeByEPCs = gql`
  query ResolveAssetTreeByEPCs($epcs: [String]!) {
    assetTreeByEPCs(epcs: $epcs) {
      cuid, label,
      children {
        cuid label
        children {
          cuid label
          children {
            cuid label
            children {
              cuid label
              children {
                cuid label
              }
            }
          }
        }
      }
    }
  }
`;

export const registerAssetsForArticle = gql`
  mutation RegisterAssetForArticle($articleCuid:String!, $assetsData: [AssetInput]!) {
    registerAssetsForArticle(articleCuid: $articleCuid, assetsData:$assetsData) {
      cuid, label, created_at, updated_at
      administration_unit {cuid label}
      article {cuid label}
      identities {cuid ean is_seal}
    }
  }
`;

@Injectable()
export class RfidService extends VisbosService {

  @select(['session', 'activeAdminUnit'])
  activeAdminUnit$: Observable<string>;

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getReaderForMarriage() {
    return environment.rfid.marry_reader_cuid;
  }

  public retrieveEPCsFromReader(variables: RetrieveEPCsByReaderQueryVariables, fetchPolicy?: FetchPolicy): ApolloQueryObservable<RetrieveEPCsByReaderQuery> {
    const opt: WatchQueryOptions = {
      query: retrieveEPCsFromReader,
      variables: variables,
    };
    if (fetchPolicy) {
      opt.fetchPolicy = fetchPolicy;
    }
    return this.fetchItems(opt);
  }

  public retrievePackingEpcsFromReader(variables: RetrievePackingEPCsByReaderQueryVariables, fetchPolicy?: FetchPolicy): ApolloQueryObservable<RetrievePackingEPCsByReaderQuery> {
    const opt: WatchQueryOptions = {
      query: retrievePackingEPCsFromReader,
      variables: variables,
    };
    if (fetchPolicy) {
      opt.fetchPolicy = fetchPolicy;
    }
    return this.fetchItems(opt);
  }

  public retrieveEPCsFromReaderOnce(variables: RetrieveEPCsByReaderQueryVariables): Observable<ApolloQueryResult<RetrieveEPCsByReaderQuery>> {

    const opt: WatchQueryOptions = {
      query: retrieveEPCsFromReader,
      variables: variables,
    };

    return this.fetchItemsOnce(opt);
  }

  public resolveEPCs(variables: ResolveItemsByEPCsQueryVariables, fetchPolicy?: FetchPolicy): ApolloQueryObservable<ResolveItemsByEPCsQuery> {
    const opt: WatchQueryOptions = {
      query: resolveItemsByEPCs,
      variables: variables,
    };
    if (fetchPolicy) {
      opt.fetchPolicy = fetchPolicy;
    }
    return this.fetchItems(opt);
  }

  public resolveEPCsOnce(variables: ResolveItemsByEPCsQueryVariables): Observable<ApolloQueryResult<ResolveItemsByEPCsQuery>> {
    const opt: WatchQueryOptions = {
      query: resolveItemsByEPCs,
      variables: variables,
    };
    return this.fetchItemsOnce(opt);
  }

  public resolveAssetTreeFromEPCs(variables: ResolveAssetTreeByEPCsQueryVariables, fetchPolicy?: FetchPolicy): ApolloQueryObservable<ResolveAssetTreeByEPCsQuery> {
    const opt: WatchQueryOptions = {
      query: resolveAssetTreeByEPCs,
      variables: variables,
    };
    if (fetchPolicy) {
      opt.fetchPolicy = fetchPolicy;
    }
    return this.fetchItems(opt);
  }

  public resolveAssetTreeFromEPCsOnce(variables: ResolveAssetTreeByEPCsQueryVariables): Observable<ApolloQueryResult<ResolveAssetTreeByEPCsQuery>> {
    const opt: WatchQueryOptions = {
      query: resolveAssetTreeByEPCs,
      variables: variables,
    };
    return this.fetchItemsOnce(opt);
  }

  public registerAssetsForArticle(variables: RegisterAssetForArticleMutationVariables): Observable<ApolloQueryResult<RegisterAssetForArticleMutation>> {
    return this.mutate({
      mutation: registerAssetsForArticle,
      variables: variables
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/identity/services/rfid.service.ts